import { render, staticRenderFns } from "./popupBg.vue?vue&type=template&id=56875188&scoped=true&"
import script from "./popupBg.vue?vue&type=script&lang=js&"
export * from "./popupBg.vue?vue&type=script&lang=js&"
import style0 from "./popupBg.vue?vue&type=style&index=0&id=56875188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56875188",
  null
  
)

export default component.exports